<template>
  <div class="administrativePage">
    <!-- <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    > -->
    <div class="forestTab">
      <van-tabs v-model="activeName">
        <van-tab title="政区信息" name="dutyAreatMsg" class="baseMsg zqInfo">
          <van-cell-group class="forestInput">
            <van-field
              :value="baseData.gridName ? baseData.gridName : '无'"
              readonly
              label="责任区名称："
            />
            <van-field
              :value="getGridLevel(baseData.gridLevel)"
              readonly
              label="责任区级别："
            />
            <van-field
              :value="baseData.area ? baseData.area : '无'"
              readonly
              label="面积(公顷)："
            />
            <van-field
              rows="1"
              autosize
              type="textarea"
              v-for="(item, index) in baseData.gridPostList"
              :key="index"
              :value="item.userNames ? item.userNames : '无'"
              readonly
              :label="item.post + '：'"
            />

            <div class="area clearfix">
              <dl class="clearfix">
                <dt class="fl">所属政区：</dt>
                <dd class="areaName fr">
                  <span>{{
                    baseData.regionName ? baseData.regionName : "无"
                  }}</span>
                  <span
                    class="firstName"
                    v-for="(item, index) in baseData.regionPostList"
                    :key="index"
                  >
                    {{ item.post }}：<span>{{
                      item.userNames ? item.userNames : "无"
                    }}</span>
                  </span>
                </dd>
              </dl>
            </div>
          </van-cell-group>
        </van-tab>
        <van-tab title="资源信息" name="dutyMsg" class="baseMsg">
          <div class="dutyMsg" id="dutyMsg">
            <div class="msgList" v-if="this.recordData != ''">
              <ul>
                <li>
                  <p class="clearfix">
                    <span>责任区面积</span>
                    <span>公顷</span>
                  </p>
                  <p>{{ recordData.gridArea }}</p>
                  <p>{{ recordData.gridName }}</p>
                </li>
                <li class="foresM">
                  <p class="clearfix">
                    <span>林地面积</span>
                    <span>公顷</span>
                  </p>
                  <p>
                    {{
                      recordData.xiaoBanInfoResult == null
                        ? "0"
                        : recordData.xiaoBanInfoResult.xiaoBanArea
                    }}
                  </p>
                  <p class="clearfix">
                    <span
                      >林地小班
                      {{
                        recordData.xiaoBanInfoResult == null
                          ? "0"
                          : recordData.xiaoBanInfoResult.xiaoBanNumber
                      }}
                      个</span
                    >
                    <span
                      >森林覆盖率
                      {{
                        recordData.xiaoBanInfoResult == null
                          ? "0"
                          : recordData.xiaoBanInfoResult.fractionCoverage
                      }}
                      %</span
                    >
                  </p>
                </li>
                <li>
                  <p class="clearfix">
                    <span>湿地面积</span>
                    <span>公顷</span>
                  </p>
                  <p>
                    {{
                      recordData.shidiInfoResult == null
                        ? "0"
                        : recordData.shidiInfoResult.shiDiArea
                    }}
                  </p>
                  <p>
                    <span
                      >湿地小班
                      {{
                        recordData.shidiInfoResult == null
                          ? "0"
                          : recordData.shidiInfoResult.shiDiNumber
                      }}
                      个</span
                    >
                  </p>
                </li>
                <!-- <li class="oldtree" v-if=" this.recordData.gushuList.lenght !=0 "> -->
                <li class="oldtree">
                  <p class="clearfix">
                    <span>古树名木</span>
                    <span>株</span>
                  </p>
                  <p>
                    {{
                      recordData.gushuListCount == ""
                        ? 0
                        : recordData.gushuListCount
                    }}
                  </p>
                  <p class="clearfix">
                    <span
                      v-for="(item, index) in recordData.gushuList"
                      :key="index"
                      >{{ item.gsDj }}
                      {{ item.gsDjNumber ? item.gsDjNumber : "0" }}</span
                    >
                  </p>
                </li>
                <li>
                  <p class="clearfix">
                    <span>林长</span>
                    <span>个</span>
                  </p>
                  <p>{{ recordData.lzCount }}</p>
                  <p>护林员 {{ recordData.ylyyCount }} 个</p>
                </li>
                <li>
                  <p class="clearfix">
                    <span>协同单位</span>
                    <span>个</span>
                  </p>
                  <p>{{ recordData.xtdwInfoResult.xtdwCount }}</p>
                  <p>
                    {{
                      recordData.xtdwInfoResult.xtdwCount == "0"
                        ? "暂无"
                        : recordData.xtdwInfoResult.xtdwName
                    }}
                  </p>
                </li>
              </ul>
              <div
                class="eChartDataBox"
                v-if="diData || woodsData || gchengData || linZData || sDiData"
              >
                <h5>林地</h5>
                <div class="forsetChart barUnit" v-if="this.diData">
                  <!-- 地类 -->
                  <p>地类</p>
                  <span class="units">单位：小班</span>
                  <gg-bar-chart :sourceList="diData"></gg-bar-chart>
                </div>
                <div class="woodsChart cicleUnit" v-if="this.woodsData">
                  <!-- 森林类别 -->
                  <p>森林（林地）类别</p>
                  <span class="units">单位：小班</span>
                  <gg-cicle-chart :sourceList="woodsData"></gg-cicle-chart>
                </div>
                <div class="gChengChart barUnit" v-if="this.gchengData">
                  <!-- 工程类别 -->
                  <p>工程类别</p>
                  <span class="units">单位：小班</span>
                  <gg-bar-chart :sourceList="gchengData"></gg-bar-chart>
                </div>
                <div class="linZChart barUnit" v-if="this.linZData">
                  <!-- 工程类别 -->
                  <p>林种类别</p>
                  <span class="units">单位：小班</span>
                  <gg-bar-chart :sourceList="linZData"></gg-bar-chart>
                </div>
                <h5 v-if="this.sDiData">湿地</h5>
                <div class="linZChart barUnit" v-if="this.sDiData">
                  <!-- 工程类别 -->
                  <p>湿地型</p>
                  <span class="units">湿地数量：个</span>
                  <gg-bar-chart :sourceList="sDiData"></gg-bar-chart>
                </div>
              </div>
            </div>
          </div>
          <div class="nonePage" v-if="this.recordData == ''">
            <img :src="nonePng" alt />
            <p>暂无数据</p>
          </div>
        </van-tab>

        <van-tab
          title="电子公示牌"
          name="dutyAreaPublicity"
          class="dutyAreaPublicity"
        >
          <div class="publicityBox" id="publicityBox">
            <ul class="itemBox" v-if="this.listData.length > 0">
              <li v-for="item in listData" :key="item.id" class="itemList">
                <p class="itemHeader">
                  <span>{{ item.realName }}</span>
                  <span>{{ item.post }}</span>
                </p>
                <van-cell-group class="itemMain">
                  <van-field
                    :value="`${getGrigType(item.gridLevel)}`"
                    readonly
                    label="级别"
                  />
                  <van-field
                    :value="`${item.position ? item.position : '/'}`"
                    readonly
                    label="职务"
                  />
                  <van-field
                    :value="`${item.orgIdName ? item.orgIdName : '/'}`"
                    readonly
                    label="工作单位"
                  />
                  <van-field
                    :value="`${
                      item.jurisdictionName ? item.jurisdictionName : '/'
                    }`"
                    readonly
                    label="管护范围"
                  />
                </van-cell-group>
              </li>
            </ul>
            <div class="nonePage" v-if="this.listData.length < 1">
              <img :src="nonePng" alt />
              <p>暂无数据</p>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 网络失败 -->
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/*eslint-disable*/
const refreshPage = () => import("@/components/common/refreshPage");
const ggBarChart = () => import("@/components/common/barChart");
const ggCicleChart = () => import("@/components/common/cicleChart");
// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "administrativeAreaMsg",
  components: {
    ggBarChart,
    ggCicleChart,
  },
  data() {
    return {
      showNonePage: true,
      objid: "", //objid
      regionLevel: "", //政区等级
      regionCode: "", //政区code
      baseData: {},
      refreshPage: false,
      activeName: "dutyAreatMsg",
      nonePng: nonePng, //默认图片
      recordData: {
        gridArea: "",
        gridName: "",
        xiaoBanInfoResult: {
          xiaoBanArea: "",
          xiaoBanNumber: "",
          fractionCoverage: "",
          coverageArea: "",
        },
        shidiInfoResult: { shiDiArea: "", shiDiNumber: "" },
        gushuList: [],
        lzCount: "",
        ylyyCount: "",
        xtdwInfoResult: { xtdwCount: "", xtdwName: "" },
      },
      diData: [], //地类
      woodsData: [], //森林类别
      gchengData: [], //工程类别
      linZData: [], //林种类别
      sDiData: [], //湿地类别
      listData: [],
      clientType: "", //手机类型
    };
  },
  props: {
    param: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    document.title = "政区信息";
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.regionCode = this.$route.query.regionCode;
      this.regionLevel = this.$route.query.regionLevel;
      this.objid = this.$route.query.commonId;
      if (this.objid == undefined) {
        console.log(JSON.stringify(this.param));
        if (this.param.type == "geo_sheng") {
          this.regionLevel = "1";
        } else if (this.param.type == "geo_shi") {
          this.regionLevel = "2";
        } else if (this.param.type == "geo_xian") {
          this.regionLevel = "3";
        } else if (this.param.type == "geo_xiang") {
          this.regionLevel = "4";
        } else if (this.param.type == "geo_cun") {
          this.regionLevel = "5";
        } else {
          this.regionLevel = "1";
        }

        this.regionCode = this.param.zqCode;
        this.objid = this.param.id;
      }
      if (this.objid && this.regionCode) {
        this.getBaseMsg();
        this.getZqzyMsg();
        this.initGongShipai();
        this.showNonePage = false;
      }
    });
    // this.objid = "3408";
    // this.regionLevel="2";
    // this.initPage();
  },
  components: {
    refreshPage,
  },
  methods: {
    getGridLevel(num) {
      let gradeName = "";
      if (num == "1") {
        gradeName = "省级";
      } else if (num == "2") {
        gradeName = "市级";
      } else if (num == "3") {
        gradeName = "县/区级";
      } else if (num == "4") {
        gradeName = "乡/镇级";
      } else if (num == "5") {
        gradeName = "村级";
      } else {
        gradeName = "无";
      }
      return gradeName;
    },
    getGridType(grid) {
      let type = "";
      if (grid == "1") {
        type = "geo_sheng";
      } else if (grid == "2") {
        type = "geo_shi";
      } else if (grid == "3") {
        type = "geo_xian";
      } else if (grid == "4") {
        type = "geo_xiang";
      } else {
        type = "geo_cun";
      }
      return type;
    },
    getPostName(text) {
      let name = "";
      if (text == "lz") {
        name = "林长";
      } else if (text == "flz") {
        name = "副林长";
      } else if (text == "ylyj") {
        name = "一林一技";
      } else if (text == "ylyjing") {
        name = "一林一警";
      } else if (text == "ylyy") {
        name = "一林一员";
      } else if (text == "xtdw") {
        name = "协同单位";
      } else if (text == "zlz") {
        name = "总林长";
      } else if (text == "fzlz") {
        name = "副总林长";
      }
      return name;
    },
    getBaseMsg() {
      let _this = this;
      _this.$api.universal.zqArea
        .lzUserRegionDetails({
          zqCode: _this.regionCode,
          regionLevel: _this.regionLevel,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = Object.assign({}, _this.baseData, res.data);
          } else {
            _this.$toast(res.msg);
          }
        });
    },
    getZqzyMsg() {
      let _this = this;
      _this.$api.User.myGridStatistics({
        type: this.getGridType(this.param.level),
        zqCode: this.param.zqCode,
        objId: this.param.id,
        level: this.regionLevel,
      })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            if (res.data == null || res.data.gridArea == null) {
              _this.recordData = "";
            } else {
              _this.recordData = Object.assign({}, _this.recordData, res.data);
              if (res.data.gushuList == 0) {
                _this.$set(_this.recordData, "gushuListCount", 0);
                let data = [
                  {
                    gsDjNumber: 0,
                    gsDj: "古树",
                  },
                  {
                    gsDjNumber: 0,
                    gsDj: "名木",
                  },
                ];
                res.data.gushuList = res.data.gushuList.concat(data);
              } else {
                let count =
                  Number(res.data.gushuList[0].gsDjNumber) +
                  Number(res.data.gushuList[1].gsDjNumber);
                _this.$set(_this.recordData, "gushuListCount", count);
              }

              _this.initChart();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initChart() {
      let _this = this;
      _this.$api.universal.dutyArea
        .gridStatisticalChart({
          objid: _this.recordData.objid,
          zqLevel: _this.recordData.gridLevel,
          zqCode: _this.recordData.zqCode,
          areaType: _this.recordData.areaType,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.barData = res.data.diLeiList;
            //地类
            if (res.data.diLeiList.length > 0) {
              _this.diData = res.data.diLeiList;
            } else {
              _this.diData = null;
            }
            //森林地类
            if (res.data.senLinLbList.length > 0) {
              _this.woodsData = res.data.senLinLbList;
            } else {
              _this.woodsData = null;
            }
            //工程
            if (res.data.gchengLbList.length > 0) {
              _this.gchengData = res.data.gchengLbList;
            } else {
              _this.gchengData = null;
            }
            //林种
            if (res.data.linZhongList.length > 0) {
              _this.linZData = res.data.linZhongList;
            } else {
              _this.linZData = null;
            }
            //湿地
            if (res.data.shiDiXingList.length > 0) {
              _this.sDiData = res.data.shiDiXingList;
            } else {
              _this.sDiData = null;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initGongShipai() {
      //责任区电子公示牌
      let _this = this;
      _this.$api.universal.dutyArea
        .getAreaBoard(_this.getGridType(this.param.level), _this.param.zqCode, {
          gridObjid: _this.param.id,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.listData = res.data;
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    param: {
      handler: function (data) {
        let _this = this;
        // console.log(JSON.stringify())
        if (_this.param.type == "geo_sheng") {
          _this.regionLevel = "1";
        } else if (_this.param.type == "geo_shi") {
          _this.regionLevel = "2";
        } else if (_this.param.type == "geo_xian") {
          _this.regionLevel = "3";
        } else if (_this.param.type == "geo_xiang") {
          _this.regionLevel = "4";
        } else if (_this.param.type == "geo_cun") {
          _this.regionLevel = "5";
        } else {
          _this.regionLevel = "1";
        }
        console.log(data, "regionCode");
        _this.objid = data.id;
        _this.regionCode = data.zqCode;
        _this.getBaseMsg();
        _this.getZqzyMsg();
        _this.initGongShipai();
        _this.showNonePage = false;
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.administrativePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  .fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }
  .forestInput {
    .regionUserLreist {
      .van-cell {
        border-bottom: 1px solid #ebedf0;
      }
    }
    .van-cell {
      .van-field__label {
        color: #999;
        font-size: 14px;
      }
      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }
      .van-cell__title {
        width: 120px;
      }
    }
    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }
  }
  .forestTab {
    width: 100%;
    height: 100%;
    .van-tabs {
      height: 100%;
      overflow: hidden;

      .van-tabs__line {
        background-color: #4bc08a;
      }

      .van-tab--active {
        .van-tab__text {
          color: #4bc08a;
        }
      }

      .van-tabs__wrap {
        height: 45px;
      }

      .van-tabs__content {
        width: 100%;
        height: calc(100% - 45px);
        overflow: hidden;

        .van-tab__pane {
          width: 100%;
        }

        .baseMsg.van-tab__pane,
        .dutyAreaEvaluate.van-tab__pane,
        .dutyAreaPublicity.van-tab__pane,
        .dutyAreaPolicy.van-tab__pane {
          height: 100%;
          background-color: #f6f6f6;
        }
        .zqInfo {
          height: 100%;
          padding-bottom: 30px;
          overflow-y: scroll;
          .forestInput {
            .area {
              padding: 0 16px 10px 16px;
              dl {
                width: 100%;
                padding-top: 10px;
                dt {
                  width: 30%;
                  font-size: 14px;
                  color: #666;
                }

                dd {
                  max-width: 65%;
                  font-size: 14px;

                  color: #333;
                  display: block;
                  > span {
                    text-align: right;
                    display: block;
                    > span {
                      display: inline;
                      color: #2d78f4;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .publicityBox {
    width: 100%;
    height: 100%;
    // padding: 8px 16px 50px;
    // overflow-y: scroll;
    background-color: #f6f6f6;
    position: relative;
    .itemBox {
      width: 100%;
      height: 100%;
      padding: 8px 16px 70px;
      overflow-y: scroll;
      .itemList {
        width: 100%;
        margin: 10px 0;
        overflow: hidden;

        .itemHeader {
          width: 100%;
          height: 60px;
          margin: 0 auto;
          background: url("~@/assets/img/publicityIconTop.png") no-repeat center;
          background-size: 100% 100%;
          position: relative;

          span {
            position: absolute;
          }

          span:first-child {
            font-size: 16px;
            color: #666;
            font-weight: 600;
            top: 50%;
            margin-top: -14px;
            left: 20px;
          }

          span:last-child {
            font-size: 18px;
            color: #4bc08a;
            font-weight: 600;
            top: 50%;
            margin-top: -14px;
            right: 20px;
          }
        }

        .itemMain {
          width: 100%;
          min-height: 97px;
          background: url("~@/assets/img/publicityIconMain.png") no-repeat
            center;
          background-size: 100% 100%;

          .van-cell {
            background: none;
            padding: 3px 16px;

            .van-field__label {
              color: #999;
              font-size: 14px;
            }

            .van-cell__value {
              .van-field__control {
                color: #999;
                font-size: 14px;
                text-align: right;
              }
            }
          }

          .van-cell:not(:last-child)::after {
            border: 0 none;
          }
        }

        .itemMain.van-hairline--top-bottom::after {
          border-width: 0 !important;
        }

        .itemMain.van-hairline::after {
          border: 0 none;
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>